import CryptoJS from 'crypto-js'

/**
 * MD5加密函数
 * @param {string} text - 需要加密的文本
 * @returns {string} MD5加密后的字符串
 */
export function md5(text) {
  return CryptoJS.MD5(text).toString()
}
